export default __webpack_public_path__ + "c4f8d8afc0715fe19be6ae94a068e953.png";